export default __webpack_public_path__ + "static/media/create_edit_sportello.17a93788.less";